import React, {useEffect, useMemo, useState} from 'react';
import FiltersHandler from "../../../components/FiltersHandler";
import {sortAlphabetically} from "@arboxappv4/shared/src/helpers/functions";
import {getFiltersConfig} from "@arboxappv4/shared/src/helpers/filters";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {FlexRowSection} from "../../../styles/globalStyles";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import styled from "styled-components";
import {isRTL} from "../../../helpers/i18n";

const TracksHeader = (props) => {
    const { tracks, onFiltered, selectedLocation } = props;
    const box = useSelector(state => state.site.box)
    const [filtersConfig, setFiltersConfig] = useState(null);
    const {isMobile} = useScreenSize()

    const departments = useMemo(() => {
        if (tracks && box?.departments !== 0) {
            const optionsObj = tracks.reduce((acc, track) => {
                (track.membership_types ?? []).forEach(mt => {
                    if (mt.departments) {
                        acc[`dept-${mt.departments.id}`] = mt.departments;
                    }
                });
                return acc;
            }, {});
            return sortAlphabetically(Object.values(optionsObj), 'name')
        }
        return []
    }, [tracks, box?.departments]);

    useEffect(() => {
        if (box && selectedLocation && tracks !== null) {
            initFiltersConfig()
        }
    }, [box, selectedLocation, tracks, departments]);

    const initFiltersConfig = () => {
        const config = getFiltersConfig({
            locations: {
                rest: {
                    filterFunc: (obj, selected) => selected === 'all' ? true : (obj.locations_box_id === selected),
                },
            },
            ...(departments.length > 0 ? {departments} : {}),
        }, selectedLocation, t)
        setFiltersConfig(config)
    }

    return (
        <>
            {filtersConfig && Object.keys(filtersConfig).length > 0 &&
                (isMobile ?
                    <MobileAbsoluteFilter rtl={isRTL()}>
                        <FiltersHandler unfilteredData={tracks} onFiltered={onFiltered} initConfig={filtersConfig} pageName={'track'}/>
                    </MobileAbsoluteFilter>
                    :
                    <FlexRowSection flex={'unset'}>
                        <FiltersHandler unfilteredData={tracks} onFiltered={onFiltered} initConfig={filtersConfig} pageName={'track'}/>
                    </FlexRowSection>
                )
            }
        </>
    );
};

export default TracksHeader;

const MobileAbsoluteFilter = styled.div`
    position: absolute;
    top: 25px;
    right: ${({rtl}) => rtl ? 'unset' : '20px'};
    left: ${({rtl}) => rtl ? '20px' : 'unset'};
`;
